var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prior",on:{"click":_vm.click}},[_c('hi-image-prior',{attrs:{"image":_vm.images[0]}}),_c('div',{staticClass:"img-wrapper"},[_c('h2',[_vm._v("Question "+_vm._s(_vm.questionNb))])]),_c('hi-image-prior',{attrs:{"image":_vm.images[1]}}),_c('hi-image-prior',{attrs:{"image":_vm.images[2]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }